
import ButtonDefault from '@/components/ui/ButtonDefault.vue'
import InputError from '@/components/ui/InputError.vue'
import Modal from '@/components/ui/Modal.vue'
import { Terms, UserConfiguration } from '@/config/variables'
import FormTextInput from '@/components/ui/FormTextInput.vue'
import CheckboxInput from '@/components/ui/CheckboxInput.vue'
import { defineComponent, ref } from 'vue'
import {
    checkErrorsReturn,
    EValidity,
    capitalize,
    validName,
    validEmail,
    validPhone,
    validCnpj,
} from '@/use/validInput'
import { theme } from '@/config/styles'

interface IUserBasicData {
    name: string
    email: string
    cellphone: string
    cnpj: string
    company: string
    optin: boolean
    limit: string
    installment: string
}

const __default__ = defineComponent({
    props: {
        enableMessage: Boolean,
        messageResponse: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },
    components: {
        ButtonDefault,
        InputError,
        Modal,
        FormTextInput,
        CheckboxInput,
    },
    emits: ['submitForm', 'backStep'],
    setup(props, context) {
        const openedModal = ref(true)
        const user = ref({
            name: '',
            email: '',
            cellphone: '',
            cnpj: '',
            company: '',
            optin: false,
            limit: '10k',
            installment: '6x',
        })
        const inputValidationStatus = ref({
            name: EValidity.Undefined,
            email: EValidity.Undefined,
            cellphone: EValidity.Undefined,
            cnpj: EValidity.Undefined,
            company: EValidity.Undefined,
            optin: EValidity.Undefined,
        })

        const resetForm = (): void => {
            const emptyUser = {
                name: '',
                email: '',
                cellphone: '',
                cnpj: '',
                company: '',
                optin: false,
                limit: '10k',
                installment: '6x',
            }
            user.value = emptyUser
        }
        const validFrontForm = (user: IUserBasicData): boolean => {
            const newStatus = { ...inputValidationStatus.value }
            if (!validName(user.name)) newStatus.name = EValidity.Invalid
            else newStatus.name = EValidity.Valid
            if (!validEmail(user.email)) newStatus.email = EValidity.Invalid
            else newStatus.email = EValidity.Valid
            if (!validPhone(user.cellphone))
                newStatus.cellphone = EValidity.Invalid
            else newStatus.cellphone = EValidity.Valid
            if (!validCnpj(user.cnpj)) newStatus.cnpj = EValidity.Invalid
            else newStatus.cnpj = EValidity.Valid
            if (user.company.length < 2) newStatus.company = EValidity.Invalid
            else newStatus.company = EValidity.Valid
            if (user.optin == false) newStatus.optin = EValidity.Invalid
            else newStatus.optin = EValidity.Valid
            inputValidationStatus.value = newStatus
            if (
                inputValidationStatus.value.name == EValidity.Valid &&
                inputValidationStatus.value.email == EValidity.Valid &&
                inputValidationStatus.value.cellphone == EValidity.Valid &&
                inputValidationStatus.value.cnpj == EValidity.Valid &&
                inputValidationStatus.value.company == EValidity.Valid &&
                inputValidationStatus.value.optin == EValidity.Valid
            )
                return true
            else return false
        }
        const submitForm = (): void => {
            if (!validFrontForm(user.value)) return
            context.emit('submitForm', user.value, resetForm)
        }
        const backStep = (): void => {
            context.emit('backStep')
        }
        const openModal = (): void => {
            openedModal.value = !openedModal.value
        }

        return {
            Terms,
            UserConfiguration,
            openedModal,
            user,
            submitForm,
            backStep,
            checkErrorsReturn,
            openModal,
            inputValidationStatus,
            EValidity,
            capitalize,
            theme,
        }
    },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "2ef0866e": (_ctx.theme.colors.primary.midlight)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__